import {
  createContext,
  useContext,
  useState,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";

export interface DashboardUser {
  slug: string | null;
  id: string;
  features: "BAR_FULL" | "WHATSAPP" | "CATALOGO";
  banner_info: string | null;
  description: string | null;
  business_name: string | null;
  instagram: string | null;
  logo: { url: string } | null;
}

interface UserState {
  /**
   * Is true when the user has the feature BAR_FULL
   */
  isMenuAccount: boolean;
  language: "ES" | "EN";
  user: DashboardUser | null;
}
const UserContext = createContext<UserState>({
  isMenuAccount: false,
  language: "ES",
  user: null,
});

const DispatchContext = createContext<Dispatch<SetStateAction<UserState>>>(
  () => {}
);

interface Props {
  user: DashboardUser | null;
  children: React.ReactNode;
}

const UserProvider: React.FC<Props> = ({ children, user }) => {
  const [state, setState] = useState<UserState>({
    isMenuAccount: user?.features === "BAR_FULL",
    language: "ES",
    user: user,
  });

  useEffect(() => {
    const language = window.navigator.language.includes("es")
      ? "ES"
      : window.navigator.language.includes("en")
      ? "EN"
      : "ES";
    setState((prev) => ({
      ...prev,
      language,
    }));
  }, []);
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      user,
      isMenuAccount: user?.features === "BAR_FULL",
    }));
  }, [user]);

  return (
    <DispatchContext.Provider value={setState}>
      <UserContext.Provider value={state}>{children}</UserContext.Provider>
    </DispatchContext.Provider>
  );
};

export default UserProvider;

export const useUserContext = () => {
  const context = useContext(UserContext);

  if (context === undefined) {
    throw new Error("useUserContext should be used inside a User provider");
  }
  return context;
};

export const useUserDispatch = () => {
  const context = useContext(DispatchContext);

  if (context === undefined) {
    throw new Error("useUserDispatch should be used inside a User provider");
  }
  return context;
};
